// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weEmpowerDiv {
  height: 20vh;
  width: 14.5vw;
  position: relative;
}

.weEmpowerBox {
  width: 13vw;
  height: 16vh;
  position: absolute;
  border-radius: 1.3vw;
  border: 1px solid #fff;
  right: 0;
  top: 0;
}

.faqButton {
  width: 13vw;
  height: 16vh;
  border-radius: 1.3vw;
  border: none;
  color: #fff;
  font-size: 1vw;
  font-weight: 500;
  text-align: left;
  padding: 2vw;
  position: absolute;
  left: 0;
  bottom: 0;
  border-radius: 1.3vw;
  background: linear-gradient(137deg, #ffb6a0 0%, #f0592a 18.54%, #253c77 100%);
}

.faqButton:hover,
.faqButton:focus,
.faqButton:active {
  background: linear-gradient(137deg, #ffb6a0 0%, #f0592a 18.54%, #253c77 100%) !important;
}

.faqLinkTag {
  text-decoration: none;
}

.faqLinkTag {
  color: #fff !important;
}

.faqButtonShadow {
  width: 13vw;
  height: 16vh;
  position: absolute;
  border-radius: 1.3vw;
  border: 0.78vw solid rgba(255, 255, 255, 0.1098039216);
  right: 0;
  top: 0;
}

.faqButtonText {
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
}

.faqArrow {
  position: absolute;
  justify-content: right;
  right: 1.3vw;
  bottom: 1.3vw;
}

.faqArrowImage {
  width: 2.5vw !important;
}

.faqModal {
  width: 100% !important;
  height: 100% !important;
  flex-shrink: 0;
  border-radius: 2.6vw;
}

.faqModal .ant-modal-footer {
  padding-bottom: 24px;
  padding-right: 24px;
}

.faqModal .ant-modal .ant-modal-footer > .ant-btn + .ant-btn {
  color: white;
  background: #f0592a;
}

.faqModal .ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover button:not(:disabled),
[type=button]:not(:disabled) {
  border-color: #f0592a !important;
  color: #f0592a;
}

.faqModal .ant-modal-title {
  margin: 0;
  color: #fff;
  font-weight: 550;
  line-height: 22px;
  word-wrap: break-word;
  font-size: 1.5vw;
}
@media (max-width: 1024px) {
  .faqModal .ant-modal-title {
    font-size: 1.8rem;
  }
}
@media (max-width: 575px) {
  .faqModal .ant-modal-title {
    font-size: 1.2rem;
  }
}

.faqModal .ant-modal-header {
  padding: 2.6vw;
  color: #fff;
  background: #1d1a36;
  border-radius: 2.6vw 2.6vw 0 0;
  position: relative;
}
.faqModal .ant-modal-header::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, rgb(255, 255, 255), rgb(240, 89, 42), rgb(255, 255, 255));
}

.faqModal .ant-modal-content {
  position: relative;
  background-color: #1d1a36;
  background-clip: padding-box;
  border: 0;
  border-radius: 2.6vw;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  pointer-events: auto;
  padding: 0;
}

.faqModalClose {
  font-size: 4vh;
  color: #f0592a;
  position: absolute;
  top: 1.3vw;
  right: 1.3vw;
}
@media (max-width: 991px) {
  .faqModalClose {
    top: 0;
  }
}
@media (max-width: 600px) {
  .faqModalClose {
    font-size: 100%;
  }
}
@media (max-width: 425px) {
  .faqModalClose {
    top: -1vh;
  }
}

@media (max-width: 1200px) {
  .weEmpowerDiv {
    height: 9rem;
    width: 15rem;
  }
  .weEmpowerBox {
    width: 13rem;
    height: 7.5rem;
  }
  .faqButton {
    width: 13rem;
    height: 7.5rem;
  }
  .faqButtonShadow {
    width: 13rem;
    height: 7.5rem;
  }
}
@media (max-width: 1024px) {
  .faqButton {
    font-size: 1rem;
  }
  .weEmpowerDiv {
    margin-bottom: 2rem;
  }
}
@media (max-width: 575px) {
  .weEmpowerBox {
    border-radius: 2vw;
  }
  .faqButton {
    border-radius: 2vw;
    padding: 5vw;
  }
  .faqButtonShadow {
    border-radius: 2vw;
    border: 3vw solid rgba(255, 255, 255, 0.1098039216);
  }
  .faqArrow {
    right: 5vw;
    bottom: 5vw;
  }
  .faqArrowImage {
    width: 6vw !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/FAQButton/faqButton.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,QAAA;EACA,MAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,oBAAA;EACA,6EAAA;AACF;;AAEA;;;EAGE,wFAAA;AACF;;AAOA;EACE,qBAAA;AAJF;;AAOA;EACE,sBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,sDAAA;EACA,QAAA;EACA,MAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;AAJF;;AAOA;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AAJF;;AAOA;EACE,uBAAA;AAJF;;AAOA;EACE,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,YAAA;EACA,mBAAA;AAJF;;AAOA;;EAIE,gCAAA;EACA,cAAA;AANF;;AASA;EACE,SAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;AANF;AAOE;EAPF;IAQI,iBAAA;EAJF;AACF;AAKE;EAVF;IAWI,iBAAA;EAFF;AACF;;AAKA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAFF;AAIE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,+FAAA;AAFJ;;AAWA;EACE,kBAAA;EACA,yBAAA;EACA,4BAAA;EACA,SAAA;EACA,oBAAA;EACA,oHAAA;EAEA,oBAAA;EACA,UAAA;AATF;;AAYA;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AATF;AAWE;EAPF;IAQI,MAAA;EARF;AACF;AASE;EAVF;IAWI,eAAA;EANF;AACF;AAOE;EAbF;IAcI,SAAA;EAJF;AACF;;AAOA;EACE;IACE,YAAA;IACA,YAAA;EAJF;EAOA;IACE,YAAA;IACA,cAAA;EALF;EAQA;IACE,YAAA;IACA,cAAA;EANF;EASA;IACE,YAAA;IACA,cAAA;EAPF;AACF;AAUA;EACE;IACE,eAAA;EARF;EAWA;IACE,mBAAA;EATF;AACF;AAYA;EACE;IACE,kBAAA;EAVF;EAaA;IACE,kBAAA;IACA,YAAA;EAXF;EAcA;IACE,kBAAA;IACA,mDAAA;EAZF;EAeA;IACE,UAAA;IACA,WAAA;EAbF;EAgBA;IACE,qBAAA;EAdF;AACF","sourcesContent":[".weEmpowerDiv {\n  height: 20vh;\n  width: 14.5vw;\n  position: relative;\n}\n\n.weEmpowerBox {\n  width: 13vw;\n  height: 16vh;\n  position: absolute;\n  border-radius: 1.3vw;\n  border: 1px solid #fff;\n  right: 0;\n  top: 0;\n}\n\n.faqButton {\n  width: 13vw;\n  height: 16vh;\n  border-radius: 1.3vw;\n  border: none;\n  color: #fff;\n  font-size: 1vw;\n  font-weight: 500;\n  text-align: left;\n  padding: 2vw;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  border-radius: 1.3vw;\n  background: linear-gradient(137deg, #ffb6a0 0%, #f0592a 18.54%, #253c77 100%);\n}\n\n.faqButton:hover,\n.faqButton:focus,\n.faqButton:active {\n  background: linear-gradient(\n    137deg,\n    #ffb6a0 0%,\n    #f0592a 18.54%,\n    #253c77 100%\n  ) !important;\n}\n\n.faqLinkTag {\n  text-decoration: none;\n}\n\n.faqLinkTag {\n  color: #fff !important;\n}\n\n.faqButtonShadow {\n  width: 13vw;\n  height: 16vh;\n  position: absolute;\n  border-radius: 1.3vw;\n  border: 0.78vw solid rgba(255, 255, 255, 0.1098039216);\n  right: 0;\n  top: 0;\n}\n\n.faqButtonText {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  width: 100%;\n}\n\n.faqArrow {\n  position: absolute;\n  justify-content: right;\n  right: 1.3vw;\n  bottom: 1.3vw;\n}\n\n.faqArrowImage {\n  width: 2.5vw !important;\n}\n\n.faqModal {\n  width: 100% !important;\n  height: 100% !important;\n  flex-shrink: 0;\n  border-radius: 2.6vw;\n}\n\n.faqModal .ant-modal-footer {\n  padding-bottom: 24px;\n  padding-right: 24px;\n}\n\n.faqModal .ant-modal .ant-modal-footer > .ant-btn + .ant-btn {\n  color: white;\n  background: #f0592a;\n}\n\n.faqModal\n  .ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover\n  button:not(:disabled),\n[type=\"button\"]:not(:disabled) {\n  border-color: #f0592a !important;\n  color: #f0592a;\n}\n\n.faqModal .ant-modal-title {\n  margin: 0;\n  color: #fff;\n  font-weight: 550;\n  line-height: 22px;\n  word-wrap: break-word;\n  font-size: 1.5vw;\n  @media (max-width: 1024px) {\n    font-size: 1.8rem;\n  }\n  @media (max-width: 575px) {\n    font-size: 1.2rem;\n  }\n}\n\n.faqModal .ant-modal-header {\n  padding: 2.6vw;\n  color: #fff;\n  background: #1d1a36;\n  border-radius: 2.6vw 2.6vw 0 0;\n  position: relative;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    background: linear-gradient(\n      to right,\n      rgba(255, 255, 255, 1),\n      rgba(240, 89, 42, 1),\n      rgba(255, 255, 255, 1)\n    );\n  }\n}\n\n.faqModal .ant-modal-content {\n  position: relative;\n  background-color: #1d1a36;\n  background-clip: padding-box;\n  border: 0;\n  border-radius: 2.6vw;\n  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  pointer-events: auto;\n  padding: 0;\n}\n\n.faqModalClose {\n  font-size: 4vh;\n  color: #f0592a;\n  position: absolute;\n  top: 1.3vw;\n  right: 1.3vw;\n\n  @media (max-width: 991px) {\n    top: 0;\n  }\n  @media (max-width: 600px) {\n    font-size: 100%;\n  }\n  @media (max-width: 425px) {\n    top: -1vh;\n  }\n}\n\n@media (max-width: 1200px) {\n  .weEmpowerDiv {\n    height: 9rem;\n    width: 15rem;\n  }\n\n  .weEmpowerBox {\n    width: 13rem;\n    height: 7.5rem;\n  }\n\n  .faqButton {\n    width: 13rem;\n    height: 7.5rem;\n  }\n\n  .faqButtonShadow {\n    width: 13rem;\n    height: 7.5rem;\n  }\n}\n\n@media (max-width: 1024px) {\n  .faqButton {\n    font-size: 1rem;\n  }\n\n  .weEmpowerDiv {\n    margin-bottom: 2rem;\n  }\n}\n\n@media (max-width: 575px) {\n  .weEmpowerBox {\n    border-radius: 2vw;\n  }\n\n  .faqButton {\n    border-radius: 2vw;\n    padding: 5vw;\n  }\n\n  .faqButtonShadow {\n    border-radius: 2vw;\n    border: 3vw solid rgba(255, 255, 255, 0.1098039216);\n  }\n\n  .faqArrow {\n    right: 5vw;\n    bottom: 5vw;\n  }\n\n  .faqArrowImage {\n    width: 6vw !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
